<template>
  <section>
    <div class='input-group date'>
      <input type='text' :name="name" :id="id" @click.prevent="inputClick" class="form-control m-input" :readonly="readonly" :value="value" v-validate="validations" :placeholder="placeholder" />
      <div class="input-group-append style-calendar" @click.prevent="iconClick">
        <span class="input-group-text">
          <i :class="value === '' ? 'fa fa-calendar' : 'fa fa-trash-o'"></i>
        </span>
      </div>
    </div>
    <span v-show="errors.has(name)" class="m-form__help m--font-danger"> {{errors.first(name)}} </span>
  </section>
</template>
 
<script>
export default {
  name: 's-date-time-picker',
  props: {
    options: { default: {}, type: Object },
    readonly: { default: true, type: Boolean },
    name: { default: '', type: String },
    validations: { default: '', type: String },
    value: { default: '', type: String },
    id: { default: '', type: String },
    placeholder: { default: '', type: String },
    cleanValue: { default: false, type: Boolean },
    onlyDays: { default: false, type: Boolean }
  },
  data () {
    return {
      defaultConfig: {
        minView: 2,
        autoclose: true,
        pickerPosition: 'bottom-left',
        language: this.$i18n.locale
      }
    }
  },
  computed: {
    start_date () {
      return this.options.startDate
    },
    end_date () {
      return this.options.endDate
    }
  },
  methods: {
    iconClick () {
      window.$(this.$el.getElementsByTagName('div')[0].firstChild).focus()
      this.value === '' ? '' : this.clean()
      this.onlyDays ? this.showOnlyDays() : window.$('.datetimepicker table thead').css('display', 'table-header-group')
    },
    inputClick () {
      window.$(this.$el.getElementsByTagName('div')[0].firstChild).focus()
      this.onlyDays ? this.showOnlyDays() : window.$('.datetimepicker table thead').css('display', 'table-header-group')
    },
    onChange (event) {
      let date = event.target.value
      this.$emit('input', date)
    },
    clean () {
      if (this.value !== '') {
        const empty = document.getElementById(this.id).value = ''
        this.$emit('empty', empty)
      }
    },
    languages () {
      window.$.fn.datetimepicker.dates['es'] = {
        days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        daysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
        daysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        meridiem: ''
      }
      window.$.fn.datetimepicker.dates['pt'] = {
        days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
        daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        daysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa', 'Do'],
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje',
        meridiem: ''
      }
    },
    showOnlyDays () {
      window.$('.datetimepicker table thead').css('display', 'none')
      window.$('.datetimepicker table tr td.old').css('visibility', 'hidden')
      window.$('.datetimepicker table tr td.new').css('visibility', 'hidden')
    }
  },
  mounted () {
    let config = Object.assign({}, this.defaultConfig, this.options)
    this.languages()
    const element = window.$(this.$el.getElementsByTagName('div')[0].firstChild).datetimepicker(config)
    element.on('change', this.onChange)
  },
  destroyed () {
    window.$(this.$el.getElementsByTagName('div')[0].firstChild).off().datetimepicker('destroy')
  },
  watch: {
    start_date (newVal) {
      window.$(this.$el.getElementsByTagName('div')[0].firstChild).datetimepicker('setStartDate', newVal)
    },
    end_date (newVal) {
      window.$(this.$el.getElementsByTagName('div')[0].firstChild).datetimepicker('setEndDate', newVal)
    },
    value () {
      this.errors.remove(this.name)
    }
  }
}
</script>

<style lang="sass" scoped>
.style-calendar
  cursor: pointer
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue